import React from 'react';
import { StyleSheet } from 'react-native';

import Theme from '../../theme';
import { Icon } from '../../components';

const ConfirmedBookingIndication = () => (
    <Icon
        size={15}
        color={Theme.WHITE}
        name="md-checkmark"
        style={styles.container}
    />
)

const styles = StyleSheet.create({
    container: {
        paddingRight: 3,
    },
});

export default ConfirmedBookingIndication;
